import { render } from "./StatusCard.vue?vue&type=template&id=78168850&scoped=true"
import script from "./StatusCard.vue?vue&type=script&lang=js"
export * from "./StatusCard.vue?vue&type=script&lang=js"

import "./StatusCard.vue?vue&type=style&index=0&id=78168850&lang=scss&scoped=true"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78168850"]])

export default __exports__